import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form } from "trader.ts/ui.forms";
import {
  enrollmentid,
  enrollmentquestionid,
  formulaquestionid,
  lessongroupid,
  questiontype,
  studentid,
} from "../../../sql/classy/types";
import { questionsField } from "../../client/questionsField";
import { renderSaveButton } from "../../client/savebutton";
import * as routes from "../../routes";

type answer = {
  id: enrollmentquestionid;
  label: string;
  boolean_answer: boolean | null;
  number_answer: number | null;
  text_answer: string | null;
  select_answer: string | null;
  multiselect_answers: string[];
  questiontype: questiontype;
  ordering: number;
};

type question = {
  id: formulaquestionid;
  select_options: string[];
};

export function render(opts: {
  lessongroupid: lessongroupid;
  enrollmentid: enrollmentid;
  student: {
    id: studentid;
    firstname: string;
    lastname: string;
  };
  answers: { answer: answer; question: question | null }[];
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("questions", [], async () => {
      return questionsField<{
        id: enrollmentquestionid;
        formulaquestionid: formulaquestionid | null;
      }>(
        opts.answers.map(({ answer, question }) => ({
          ...answer,
          mandatory: false,
          id: answer.id,
          formulaquestionid: question?.id || null,
          select_options: question?.select_options || [],
        })),
      );
    })
    .build();

  return (
    <div>
      {form.render()}
      <div style="text-align: right;">
        {renderSaveButton({
          formS: form.s,
          save: async (vals) => {
            return rpc(routes.updateQuestionsSpec, undefined, {
              questions: vals.questions,
              studentid: opts.student.id,
              enrollmentid: opts.enrollmentid,
            });
          },
          reload: () =>
            (document.location = routes.lessongroup_questionsRoute.link({
              lessongroupid: opts.lessongroupid,
              orientation: "vertical",
            })),
        })}
      </div>
    </div>
  );
}
